@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  body {
    @apply m-0 font-sans antialiased;
  }

  /* Dark mode (default) */
  .dark {
    color-scheme: dark;
  }

  /* Light mode */
  .light {
    color-scheme: light;
  }
}

@layer components {
  .card {
    @apply rounded-lg border border-slate-200 bg-white p-4 shadow-sm dark:border-navy-700 dark:bg-navy-900;
  }

  .card-header {
    @apply mb-3 flex items-center justify-between border-b border-slate-200 pb-3 dark:border-navy-700;
  }

  .sensor-card {
    @apply card transition-all duration-200 hover:shadow-md dark:hover:border-teal-700;
  }

  .nav-link {
    @apply flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-navy-800 dark:hover:text-white;
  }

  .nav-link-active {
    @apply bg-teal-50 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400;
  }

  .badge {
    @apply inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium;
  }

  .badge-success {
    @apply badge bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400;
  }

  .badge-warning {
    @apply badge bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400;
  }

  .badge-danger {
    @apply badge bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400;
  }

  .badge-info {
    @apply badge bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400;
  }

  .badge-neutral {
    @apply badge bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300;
  }
}

@layer utilities {
  .text-balance {
    text-wrap: balance;
  }

  .scrollbar-thin {
    scrollbar-width: thin;
  }

  .scrollbar-dark {
    scrollbar-color: #364159 transparent;
  }
}

/* Google Maps dark mode overrides */
.dark .gm-style .gm-style-iw-d {
  background: #1E293B;
  color: #F1F5F9;
}

.dark .gm-style .gm-style-iw-c {
  background: #1E293B;
}

.dark .gm-style .gm-style-iw-tc::after {
  background: #1E293B;
}
